
export const Colors = ['#3B77FB', '#FD773B', '#E9232D', '#41DFFD']

export function getColor(index: number) {
    return Colors[index % Colors.length]
}


// WEBPACK FOOTER //
// ./src/utils/corlor.ts